export const FETCH_SAVE_SHOPPING_LIST_REQUEST = 'FETCH_SAVE_SHOPPING_LIST_REQUEST'
export const FETCH_SAVE_SHOPPING_LIST_SUCCESS = 'FETCH_SAVE_SHOPPING_LIST_SUCCESS'
export const FETCH_SAVE_SHOPPING_LIST_ERROR = 'FETCH_SAVE_SHOPPING_LIST_ERROR'
